import { useI18n } from "@/context/LanguageContext";
import { ALBUMS } from "@/data/albums";

export const Albums = () => {
  const { t } = useI18n();
  const titles = t.albums.items; // { pre: {title, subtitle}, cerimonia:{...}, ... }

  return (
    <section
      id="albums"
      data-testid="albums-section"
      className="bg-[#141518] text-[#FFF7F1] py-20 md:py-28 border-y-2 border-[#141518]"
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="font-condensed font-bold uppercase tracking-[0.3em] text-xs md:text-sm text-[#F0311B]">
          ✱ {t.albums.eyebrow}
        </div>
        <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[0.95] uppercase mt-3 max-w-3xl">
          {t.albums.title}{" "}
          <span className="text-[#F0311B]">{t.albums.titleAccent}</span>
        </h2>
        <p className="font-serif italic text-base md:text-lg mt-5 max-w-2xl text-[#FFF7F1]/80">
          {t.albums.lead}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 mt-12">
          {ALBUMS.map((al, idx) => {
            const meta = titles[al.id] || { title: al.id, subtitle: "" };
            return (
              <a
                key={al.id}
                href={al.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`album-card-${al.id}`}
                className="group block bg-[#FFF7F1] text-[#141518] border-2 border-[#FFF7F1] hover:border-[#F0311B] transition-colors duration-200 shadow-[6px_6px_0_#F0311B] hover:shadow-[10px_10px_0_#F0311B] hover:-translate-x-1 hover:-translate-y-1 transform-gpu transition-transform"
              >
                {/* preview grid */}
                <div className="grid grid-cols-2 gap-0.5 bg-[#141518]">
                  {al.previews.slice(0, 4).map((src, i) => (
                    <div key={i} className="relative aspect-square overflow-hidden bg-[#141518]">
                      <img
                        src={src}
                        alt={`${meta.title} ${i + 1}`}
                        loading="lazy"
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                  ))}
                </div>
                {/* body */}
                <div className="p-6 md:p-7 flex items-end justify-between gap-4">
                  <div>
                    <div className="font-condensed font-bold uppercase tracking-[0.25em] text-[10px] md:text-xs text-[#F0311B]">
                      ✱ {String(idx + 1).padStart(2, "0")} · {meta.subtitle}
                    </div>
                    <div className="font-display font-bold text-2xl md:text-3xl uppercase mt-2 leading-tight">
                      {meta.title}
                    </div>
                  </div>
                  <div className="font-condensed font-bold uppercase tracking-[0.2em] text-xs md:text-sm text-[#141518] shrink-0 border-b-2 border-[#F0311B] pb-1 group-hover:text-[#F0311B] transition-colors">
                    {t.albums.cta} →
                  </div>
                </div>
              </a>
            );
          })}
        </div>

        <p className="font-serif italic text-sm md:text-base mt-10 text-[#FFF7F1]/60 max-w-2xl">
          {t.albums.footnote}
        </p>
      </div>
    </section>
  );
};
